export default __webpack_public_path__ + "static/media/icons-calendar-18-px.88e10b54.svg";